module.exports = __webpack_public_path__ + "static/media/app_logo.ee875244.svg";